import React from 'react';
import { WxbSpinner } from '../Spinner/Spinner';
import './Overlay.css';

export interface WxbOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  loading: boolean;
  tip?: string;
}

/**
 * Wrapping loading overlay. The inert content wrapper prevents keyboard and
 * pointer interaction with controls while loading without removing layout.
 */
export const WxbOverlay: React.FC<WxbOverlayProps> = ({
  loading,
  tip,
  children,
  className = '',
  ...props
}) => {
  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const content = contentRef.current;
    if (!content) return;
    if (loading) content.setAttribute('inert', '');
    else content.removeAttribute('inert');
  }, [loading]);

  return (
    <div
      {...props}
      className={`wxb-overlay-container ${className}`}
      aria-busy={loading || undefined}
    >
      {loading && (
        <div className="wxb-overlay-mask">
          <WxbSpinner tip={tip} />
        </div>
      )}
      <div ref={contentRef} className="wxb-overlay-content">
        {children}
      </div>
    </div>
  );
};
